import { HTMLAttributes } from "react";

type DividerOrientation = "horizontal" | "vertical";
type DividerVariant = "solid" | "dashed" | "dotted";

interface DividerProps extends HTMLAttributes<HTMLDivElement> {
  orientation?: DividerOrientation;
  variant?: DividerVariant;
  label?: string;
}

const variantStyles: Record<DividerVariant, string> = {
  solid: "border-solid",
  dashed: "border-dashed",
  dotted: "border-dotted",
};

export function Divider({
  orientation = "horizontal",
  variant = "solid",
  label,
  className = "",
  ...props
}: DividerProps) {
  if (label && orientation === "horizontal") {
    return (
      <div className={`flex items-center gap-4 my-6 ${className}`} {...props}>
        <div
          className={`flex-1 border-t border-[var(--color-border)] ${variantStyles[variant]}`}
        />
        <span className="text-sm text-[var(--color-text-muted)] font-medium">{label}</span>
        <div
          className={`flex-1 border-t border-[var(--color-border)] ${variantStyles[variant]}`}
        />
      </div>
    );
  }

  return (
    <div
      className={`border-[var(--color-border)] ${variantStyles[variant]} ${orientation === "horizontal" ? "border-t w-full my-4" : "border-l h-full mx-4"} ${className}`}
      {...props}
    />
  );
}

export type { DividerProps };
